class CustomHeaderDrawerDesktop extends HTMLElement {
  connectedCallback() {
    this.mainDetailsToggle = this.querySelector('details');
    this.header = document.querySelector('.section-header');
    this.borderOffset = this.closest('.header-wrapper')?.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
 
    // Stored so it can be removed in disconnectedCallback (window outlives this element)
    this.onResizeHandler = this.onResize.bind(this);
    this.bindEvents();
  }
 
  disconnectedCallback() {
    window.removeEventListener('resize', this.onResizeHandler);
  }
 
  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    window.addEventListener('resize', this.onResizeHandler);
  }
 
  get isOpen() {
    return this.mainDetailsToggle?.hasAttribute('open');
  }
 
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
 
    if (detailsElement.hasAttribute('open')) {
      this.closeDrawer(summaryElement);
    } else {
      this.openDrawer(summaryElement);
    }
  }
 
  // Shared by openDrawer and onResize
  setHeaderVars() {
    const headerBottom = this.header?.getBoundingClientRect().bottom || 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${Math.round(headerBottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  }
 
  openDrawer(summaryElement) {
    this.setHeaderVars();
    summaryElement.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden-desktop');
    this.mainDetailsToggle?.classList.add('menu-opening');
    this.header?.classList.add('menu-open');
  }
 
  closeDrawer(summaryElement) {
    summaryElement?.setAttribute('aria-expanded', 'false');
    this.mainDetailsToggle?.classList.remove('menu-opening');
    document.body.classList.remove('overflow-hidden-desktop');
    this.header?.classList.remove('menu-open');
  }
 
  onResize() {
    // Coalesce rapid resize events into one update per frame,
    // and only recompute while the drawer is actually open.
    if (this.resizeRaf) return;
    this.resizeRaf = requestAnimationFrame(() => {
      this.resizeRaf = null;
      if (this.isOpen) this.setHeaderVars();
    });
  }
}
 
customElements.define('custom-header-drawer-desktop', CustomHeaderDrawerDesktop);